import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

import { RuntimeConfigService } from '../runtime-config.service';

@Injectable({
  providedIn: 'root',
})
export class EventModeGuard implements CanActivate {
  constructor(private runtimeConfig: RuntimeConfigService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    // Always redirect to /teaser if teaser mode is active
    if (this.runtimeConfig.showTeaser)
      return this.router.createUrlTree(['/teaser']);

    // For the root path: redirect based on event state
    if (route.routeConfig?.path === '') {
      return this.runtimeConfig.eventFinish
        ? this.router.createUrlTree(['/gallery'])
        : this.router.createUrlTree(['/atout']);
    }

    // For all other guarded routes (e.g. /gallery): allow access
    return true;
  }
}
